import { MEDIA_URL, STRAPI_API_URL } from '@/constants/env';
import { seo } from '@/content';
import '@/styles/globals.css';
import '@splidejs/splide/dist/css/splide.min.css';
import Head from 'next/head';
import { Toaster } from 'react-hot-toast';

function MyApp({ Component, pageProps }) {
  return (
    <>
      <Head>
        <meta content="width=device-width, initial-scale=1, maximum-scale=1" name="viewport" />
        <link
          href="https://assets.tresamigosdevelopment.com/cead-website/favicon.png"
          rel="shortcut icon"
          type="image/png"
        />
        <meta content={seo.description} name="description" />
        <meta content="TAD" name="copyright" />
        <meta content={seo.keywords} name="keywords" />
        <meta content="website" property="og:type" />
        <meta content={seo.description} name="description" property="og:description" />
        <meta content={seo.image} property="og:image" />
        <meta content="summary_large_image" property="twitter:card" />
        <meta content={seo.description} property="twitter:description" />
        <meta content={seo.image} property="twitter:image" />
      </Head>
      <Component {...pageProps} />
      <Toaster position="bottom-left" reverseOrder={true} />
    </>
  );
}

export default MyApp;
